import { Injectable } from "@angular/core";
import { SearchConfigurationModel } from "apps-module/app/entry-modules/content-search/models/search-configuration.model";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/content-search/models/form-search-parameters.model";
import { QuerySearchParametersModel } from "apps-module/app/entry-modules/content-search/models/query-search-parameters.model";
import { QueryStringSerializationService } from "apps-module/app/shared-library/services/environment/query-string-serialization.service";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";
import { NumericUtils } from "apps-module/app/shared-library/utils/numeric.utils";

@Injectable()
export class FormSearchParametersService {

    public constructor(
        private _serializationService: QueryStringSerializationService
    ) {
    }

    public create(queryString: string, configuration: SearchConfigurationModel): FormSearchParametersModel {
        const rawValues = this._serializationService.deserialize(queryString);

        const formParameters = {
            homePageId: configuration.homePageId,
            pageNumber: NumericUtils.parse(rawValues[nameof<QuerySearchParametersModel>("pageNumber")] as string, 1),
            sortOption: rawValues[nameof<QuerySearchParametersModel>("sortOption")] as string || "Rank;asc",
            searchText: rawValues[nameof<QuerySearchParametersModel>("searchText")] as string || "",
            topics: rawValues[nameof<QuerySearchParametersModel>("topics")] as Array<string> || [],
            contentTypes: rawValues[nameof<QuerySearchParametersModel>("contentTypes")] as Array<string> || [],
            audience: rawValues[nameof<QuerySearchParametersModel>("audience")] as Array<string> || []
        } as FormSearchParametersModel;

        return formParameters;
    }
}
